import { render, staticRenderFns } from "./TextTag.vue?vue&type=template&id=46a846ec&scoped=true&"
import script from "./TextTag.vue?vue&type=script&lang=js&"
export * from "./TextTag.vue?vue&type=script&lang=js&"
import style0 from "./TextTag.vue?vue&type=style&index=0&id=46a846ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a846ec",
  null
  
)

export default component.exports